import { Box, Typography, Grid } from "@mui/material";
import { grey } from "@mui/material/colors";
import React from "react";
import { useAppContext } from "@/contexts/AppContext.tsx";
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import { UICardContent, UICardHeadingLight } from "@/components/Shared/Utils/UICard";

function DarkLightSwitcher({ disabled }: { disabled?: boolean }) {
    const { theme, setTheme } = useAppContext();
    const [left, setLeft] = React.useState(theme === 'dark' ? 25 : 1);

    function handleSwitchTheme() {
        setLeft(left === 1 ? 25 : 1);

        const value = theme === 'dark' ? 'light' : 'dark';
        localStorage.setItem("theme", value);
        setTheme(value);
    }

    return (
        <Box
            width={48}
            height={24}
            position="relative"
            bgcolor={grey[300]}
            borderRadius={30}
            sx={{ cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.25 : 1 }}
            onClick={() => !disabled && handleSwitchTheme()}
        >
            <Box
                width={22}
                height={22}
                bgcolor={theme === 'dark' ? grey[800] : grey[50]}
                position="absolute"
                zIndex={1}
                top={1}
                left={left}
                sx={{ transition: 'left linear 0.2s' }}
                borderRadius={30}
            />
            <LightModeRoundedIcon sx={{ fontSize: 18, position: 'absolute', right: 5, top: 3 }} />
            <DarkModeRoundedIcon sx={{ fontSize: 18, position: 'absolute', left: 5, top: 3 }} />
        </Box>
    )
}

export default function ManageAppSettings() {
    const { uiVisual, setVisual, theme } = useAppContext();

    function handleToggleVisual(value: 'classic' | 'modern') {
        localStorage.setItem("visual", value);
        setVisual(value);
    }

    return (
        <>
            <UICardHeadingLight
                title="App Settings"
                description="Customize your application appearance and behavior"
            />
            <UICardContent>
                <Box p={2}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Box mb={1}>
                                <Typography fontSize={14} fontWeight={500}>Theme</Typography>
                                <Typography fontSize={12} color={grey[700]}>
                                    Choose between light and dark theme
                                </Typography>
                            </Box>
                            <Box>
                                <DarkLightSwitcher />
                                <Typography fontSize={13} color={grey[700]}>
                                    {uiVisual === 'classic' ?
                                        `Currently using ${theme === 'dark' ? 'Dark' : 'Light'} theme` :
                                        `${theme === 'dark' ? 'Dark' : 'Light'} mode`}
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            <Box mb={1}>
                                <Typography fontSize={14} fontWeight={500}>UI Style</Typography>
                                <Typography fontSize={12} color={grey[700]}>
                                    Select your preferred interface style
                                </Typography>
                            </Box>
                            <Box>
                                <Typography
                                    fontSize={13}
                                    sx={{ cursor: 'pointer', textDecoration: 'underline', color: grey[700] }}
                                    onClick={() => handleToggleVisual(uiVisual === 'classic' ? 'modern' : 'classic')}>
                                    Switch to {uiVisual === 'classic' ? 'Modern' : 'Classic'} UI
                                </Typography>
                                <Typography fontSize={13} color={grey[700]}>
                                    (Currently using {uiVisual === 'classic' ? 'Classic' : 'Modern'})
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </UICardContent>
        </>
    );
} 